import {useListView} from '../core/ListViewProvider'
import {HotelsListToolbar} from './HotelListToolbar'
import {HotelsListGrouping} from './HotelListGrouping'
import {HotelsListSearchComponent} from './HotelsListSearchComponent'

const HotelsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6 pb-4 flex-wrap gap-3'>
      <div className='d-flex align-items-center gap-3 flex-grow-1'>
        <HotelsListSearchComponent />
      </div>
      <div className='card-toolbar ms-auto'>
        {selected.length > 0 ? <HotelsListGrouping /> : <HotelsListToolbar />}
      </div>
    </div>
  )
}

export {HotelsListHeader}
